/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Unscheduled_HintInputs */

const en_tl_unscheduled_hint = /** @type {(inputs: Tl_Unscheduled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag onto the timeline to give an item a week from there.`)
};

const de_tl_unscheduled_hint = /** @type {(inputs: Tl_Unscheduled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf die Zeitleiste ziehen, um einem Vorgang ab dort eine Woche zu geben.`)
};

/**
* | output |
* | --- |
* | "Drag onto the timeline to give an item a week from there." |
*
* @param {Tl_Unscheduled_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_unscheduled_hint = /** @type {((inputs?: Tl_Unscheduled_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Unscheduled_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_unscheduled_hint(inputs)
	return en_tl_unscheduled_hint(inputs)
});